import { CatalogueRepository } from "@catalogue/data/repositories/catalogue.repository";
import { Derivation } from "@catalogue/domain/models/derivation.model";
import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";

export interface UpdateDerivationData {
    id: number;
    beneficiaryId: number;
    serviceId: number;
    entityId: number;
    assignedById: number;
    status?: string;
    reason?: Nullable<string>;
    documentIds?: number[];
    authorizationFileId?: Nullable<number>;
    notify_admin_id?: number;
}

@injectable()
export class UpdateDerivationUseCase {
    constructor(
        @inject(CatalogueRepository)
        private readonly catalogueRepository: CatalogueRepository,
    ) { }

    async execute(
        derivation: UpdateDerivationData
    ): Promise<Nullable<Derivation>> {
        const updateResult = await this.catalogueRepository.updateDerivation(derivation);

        if (updateResult.isLeft()) {
            ToastManagerStore.error(updateResult.getLeftOrThrow().message);
        }

        return updateResult.fold(
            () => null,
            (updatedDerivation) => updatedDerivation
        );
    }
}